import { render, staticRenderFns } from "./RecentPages.vue?vue&type=template&id=0f6cd438&scoped=true"
import script from "./RecentPages.vue?vue&type=script&lang=js"
export * from "./RecentPages.vue?vue&type=script&lang=js"
import style0 from "./RecentPages.vue?vue&type=style&index=0&id=0f6cd438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cd438",
  null
  
)

export default component.exports